import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

function Dashboard() {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 5;
    const userdetail = JSON.parse(localStorage.getItem("UserData"));
    // Fetch data
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await fetch(`https://admin.energybazzar.com/api/user/adds/${userdetail?.id}`, {
                method: "GET",
            });
            const result = await response.json();
            if (result?.status) {
                setData(result.data?.user_adds); // assuming API returns an array
            }

        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Delete item
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this record?")) return;

        try {
            await fetch(`https://admin.energybazzar.com/api/user/adds/delete/${id}`, {
                method: "DELETE",
            });
            setData(data.filter((item) => item.id !== id));
            toast.success("Deleted successfully!");
        } catch (err) {
            console.error("Delete error:", err);
            toast.error("Error deleting record.");
        }
    };

    // Search filter
    const filteredData = data.filter(
        (item) =>
            item.title.toLowerCase().includes(search.toLowerCase()) ||
            item.email.toLowerCase().includes(search.toLowerCase())
    );

    // Pagination logic
    const indexOfLast = currentPage * itemsPerPage;
    const indexOfFirst = indexOfLast - itemsPerPage;
    const currentData = filteredData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    return (
        <>
           
            <div className="container mt-1">
                <h3 className="mb-4">Your Listing</h3>

                {/* Search */}
                <div className="row mb-3">
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by Title or Email..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>

                {/* Table */}
                <table className="table table-bordered table-striped">
                    <thead className="">
                        <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="8" className="text-center">
                                    <div className="spinner-border text-primary" role="status"></div>
                                </td>
                            </tr>
                        ) : currentData.length > 0 ? (
                            currentData.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{indexOfFirst + index + 1}</td>
                                    <td>{item.title}</td>
                                    <td>{item.email}</td>
                                    <td>{item.address}</td>
                                    <td>
                                        <img
                                            src={item.media[0]?.original_url}
                                            alt="img"
                                            style={{ width: "60px", height: "60px", objectFit: "cover" }}
                                        />
                                    </td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-primary me-2"
                                            onClick={() => (window.location.href = `dashboard/edit-ad/${item.slug}`)}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() => handleDelete(item.id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center">
                                    No records found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Pagination */}
                <nav>
                    <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => setCurrentPage((prev) => prev - 1)}
                            >
                                Previous
                            </button>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                            <li
                                key={i}
                                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                            >
                                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                                    {i + 1}
                                </button>
                            </li>
                        ))}
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => setCurrentPage((prev) => prev + 1)}
                            >
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </>
    )
}

export default Dashboard;